import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = (k, d) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? d;
  } catch {
    return d;
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => load("pg_cart", []));
  const [academy, setAcademy] = useState(() => load("pg_academy", null));

  useEffect(() => {
    localStorage.setItem("pg_cart", JSON.stringify(items));
  }, [items]);
  useEffect(() => {
    localStorage.setItem("pg_academy", JSON.stringify(academy));
  }, [academy]);

  const addItem = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (p) => p.product_id === item.product_id && p.color === item.color && p.colorway === item.colorway
          && p.audience === item.audience && p.size === item.size
          && JSON.stringify(p.customization || {}) === JSON.stringify(item.customization || {})
      );
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + item.qty };
        return copy;
      }
      return [...prev, item];
    });
  };

  const updateQty = (i, qty) =>
    setItems((prev) => prev.map((p, idx) => (idx === i ? { ...p, qty: Math.max(1, qty) } : p)));
  const removeItem = (i) => setItems((prev) => prev.filter((_, idx) => idx !== i));
  const clear = () => {
    setItems([]);
  };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, academy, setAcademy, addItem, updateQty, removeItem, clear, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
